<template>
  <div class="card mb-4">
    <div class="card-header">
      <strong>Resumo</strong>
    </div>
    <div class="card-body">
      <div class="mb-3">
        <span class="loading-placeholder col-md-8 mb-2"></span>
        <br>
        <span class="loading-placeholder thin col-md-6"></span>
        <br>
        <span class="loading-placeholder thin col-md-6"></span>
        <br>
        <span class="loading-placeholder thin col-md-7"></span>
        <br>
        <span class="loading-placeholder thin col-md-7"></span>
      </div>
      <hr>
      <div>
        <span class="loading-placeholder col-md-7 mb-2"></span>
        <br>
        <span class="loading-placeholder thin col-md-5"></span>
        <br>
        <span class="loading-placeholder thin col-md-5"></span>
        <br>
        <span class="loading-placeholder thin col-md-6"></span>
        <br>
        <span class="loading-placeholder thin col-md-6"></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SkeletonSummary'
}
</script>

